const state = {
    sm_products: [],
    sm_product: {},
    sm_product_filters: {},
    sm_product_vat_list: {},
}

export default state;
